var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.back}},[_c('v-icon',[_vm._v(" mdi-chevron-left ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }